import { useMemo } from "react"

import RecentMailItem from "./RecentMailItem"
import { useMostRecentMailQuery } from "../../../../networking/families/queries"
import { useFamilyQuery } from "../../../../networking/queries"
import { FamilyQuerySelect } from "../../../../types"
import {
  getMostRecentMessage,
  sortChildrenByRecentMail,
} from "../../../../util/mail"

const AllChildrenMailbox = () => {
  const { data: children } = useFamilyQuery(FamilyQuerySelect.CHILDREN)
  const { data: recentMail } = useMostRecentMailQuery()
  const sortedChildren = useMemo(
    () =>
      children && recentMail
        ? sortChildrenByRecentMail(children, recentMail)
        : [],
    [children, recentMail]
  )

  return (
    <div className="flex flex-col gap-2">
      {sortedChildren.map((child) => {
        if (!recentMail) return null
        const message = getMostRecentMessage(recentMail, child.user.id)
        return (
          <RecentMailItem key={child.user.id} mail={message} child={child} />
        )
      })}
    </div>
  )
}

export default AllChildrenMailbox
